import Vue from 'vue';
import Siema from 'siema';
import DeepNav from '../components/DeepNav.vue';
import StudentWork from '../components/StudentWork.vue';
import MediaHeader from '../components/MediaHeader.vue';
import GlobalModal from '../components/GlobalModal.vue';
import { EventBus } from '../event-bus.js'
import h from 'hyperscript';

export default (app) => {
  // Deepnav
  // ---------------------------------------------------------------------------
  if (window.navigator.userAgent.indexOf("Edge") > -1) {
    console.log('The comprehensive main navigation is not yet supported in Edge')
  } else {
    app.deepNav = new Vue({
      name: 'Menu',
      el: document.getElementById('js-deep-nav'),
      render: (createElement) => {
        return createElement(DeepNav, { ref: 'deep-nav' });
      }
    });

    const deepNavComponent = app.deepNav.$refs['deep-nav']

    // Set up event listeners on the category links of the non-JS menu to trigger
    // changes in DeepNav state on hover
    const menuLinks = document.querySelectorAll('#js-menu a');
    const searchToggle = document.querySelector('.js-find-toggle')
    const show = deepNavComponent.show
    const hide = deepNavComponent.hide

    // Targets the menu and deep nav elements
    const menu = document.querySelector('#js-menu');
    const menuToggle = document.querySelector('.js-header__mobile-menu-button')

    const deepNav = document.querySelector('#deep-nav');
    const main_header = document.querySelector('.document__header');

    // Shows the deep nav when a menu item is moused over
    menuLinks.forEach(link => {
      link.addEventListener('mouseover', e => { 

        menuLinks.forEach(link1 => {
          link1.classList.remove('with-border')
        })
        
        e.target.classList.add('with-border')
        
        if(e.target['className'] != 'link-list__link channel-link'){
          show(e)
        }
      } );
      link.addEventListener('focus', e => { 
        menuLinks.forEach(link2 => {
          link2.classList.remove('with-border')
        })
        e.target.classList.add('with-border')

        if (e.target['className'] != 'link-list__link js-find-toggle' || e.target['className'] != 'link-list__link channel-link'){
          show(e)
        }
      } );

      link.addEventListener('click', e => { 
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
           'event': 'menu_clicks',
           'button_name': link.textContent
        })
      });
    })
  

    searchToggle.addEventListener('click', e => {
      EventBus.$emit('focus-search');
    });

    // Hide the deep nav when the mouse leaves the menu,
    // unless the mouse immediately enters any element inside the deep nav,
    // in which case it should stay open for navigation
    // (e.relatedTarget is the first element touched after a mouseleave)
    menu.addEventListener('mouseleave', e => {
      if ( e.relatedTarget !== deepNavComponent.$el && deepNavComponent.$el.contains(e.relatedTarget) ) {
        return
      } else {
        menuLinks.forEach(link3 => {
          link3.classList.remove('with-border')
        })
        setTimeout(function () {
          hide()
        }, 100)
      }
    });

    deepNav.addEventListener('mouseleave', e => {
      menuLinks.forEach(link4 => {
        link4.classList.remove('with-border')
      })
    });

    menuToggle.addEventListener('click', e => {
      if ( deepNavComponent.isVisible ) {
        main_header.classList.remove('menu_open')
        deepNav.classList.remove('menu_open')
        hide(e)
      } else {
        main_header.classList.add('menu_open')
        deepNav.classList.add('menu_open')
        show(e)
      }
    });

    
    searchToggle.addEventListener('keydown', e => {
      if(e.keyCode == 13 || e.which == 13){
        show(e)
        EventBus.$emit('focus-search');
      }
    });    

    //if we have a notification div, move mobile menu down
    const $menuMobile = document.querySelector('.deep-nav');
    if(document.querySelector('.notification') !== null) {
      $menuMobile.classList.add('with-notification');
    }
  }

  // Images
  // ---------------------------------------------------------------------------
  const $images = document.querySelectorAll('.js-responsive-image__image');

  const markImageAsComplete = ($i) => $i.classList.add('responsive-image__image--is-loaded');

  $images.forEach(($img) => {
    if ($img.complete) {
      markImageAsComplete($img);
    } else {
      $img.addEventListener('load', (e) => markImageAsComplete($img));
    }
  });

  // Slideshows
  // ---------------------------------------------------------------------------
  Siema.prototype.addArrows = function() {
    // make buttons & append them inside Siema's container
    this.controls = document.createElement('nav')
    this.controls.className = 'gallery__controls'

    this.prevArrow = document.createElement('button')
    this.prevArrow.textContent = 'previous'
    this.prevArrow.className = 'gallery__control gallery__control--previous'

    this.nextArrow = document.createElement('button')
    this.nextArrow.textContent = 'next'
    this.nextArrow.className = 'gallery__control gallery__control--next'

    this.selector.insertBefore(this.controls, this.selector.firstChild)

    this.controls.appendChild(this.prevArrow)
    this.controls.appendChild(this.nextArrow)

    // event handlers on buttons
    this.prevArrow.addEventListener('click', () => this.prev())
    this.nextArrow.addEventListener('click', () => this.next())
  }

  // Query gallery lists and initialize Siema for each
  const galleries = document.querySelectorAll('.siema')

  for(const gallery of galleries) {
    const instance = new Siema({
      selector: gallery
    })
    instance.addArrows()
  }

  // Work Browser
  // ---------------------------------------------------------------------------
  const $workBrowser = document.getElementById('js-work-browser');

  if ($workBrowser) {
    app.studentWork = new Vue({
      name: 'WorkBrowser',
      el: $workBrowser,
      render: (createElement) => {
        return createElement(StudentWork);
      }
    });
  }

  // Media Header
  // ---------------------------------------------------------------------------
  const $mediaHeader = document.getElementById('js-media-header');

  if ($mediaHeader) {
    app.mediaHeader = new Vue({
      name: 'Header',
      el: $mediaHeader,
      render: (createElement) => {
        return createElement(MediaHeader, {
          props: {
            images: JSON.parse($mediaHeader.dataset.images),
            video: $mediaHeader.dataset.video
          }
        });
      },
      mounted: function() {
        setTimeout(()=>{
          renderPlayButton();
          initSkipToContent();
        }, 500);
      }
    });
  }

  //

  // Global Modal
  // ---------------------------------------------------------------------------
  const globalModal = document.querySelector('#js-global-modal');

  if (globalModal) {
    app.globalModal = new Vue({
      name: 'GlobalModal',
      el: globalModal,
      render: (createElement) => {
        return createElement(GlobalModal);
      }
    });
  }

  // Text Content
  // A few client-side things we do to elements within `text-content` blocks.
  // ---------------------------------------------------------------------------

  const $texts = document.querySelectorAll('.js-text-content');

  $texts.forEach(($text) => {
    // Tables
    const $tables = $text.querySelectorAll('table');

    $tables.forEach(($table) => {
      // Wrap in an element, so we can attach horizontal scrolling behaviors:
      const $tableWrapper = h('div.text-content__table');

      $text.insertBefore($tableWrapper, $table);
      $tableWrapper.appendChild($table);

      if ($table.offsetWidth > $tableWrapper.offsetWidth) {
        $tableWrapper.classList.add('text-content__table--is-overflowing');
      }
    });
  });
  
  var renderPlayButton = function() {
    // Play/Pause button for Video Media Header
    // ---------------------------------------------------------------------------
    const mediaHeaderVideo = document.querySelector('#media-header video');
  
    if(mediaHeaderVideo) {
      const playIcon = '<img src="/assets/images/icons/icon-play.png" alt="Play background video">';
      const pauseIcon = '<img src="/assets/images/icons/icon-pause.png" alt="Pause background video">';
      document.querySelector('#header__content').insertAdjacentHTML('beforeend', '<button class="control-button">'+pauseIcon+'</button>');
      const videoControlButton = document.querySelector('#header__content .control-button');
    
      videoControlButton.addEventListener('click', e => {
        if(mediaHeaderVideo.paused) {
          mediaHeaderVideo.play();
          videoControlButton.innerHTML = pauseIcon;
        } else {
          mediaHeaderVideo.pause();
          videoControlButton.innerHTML = playIcon;
        }
      });
    }
  };
  
  var initSkipToContent = function() {
    var mainContent = document.getElementById("main-content"),
        skipButton = document.getElementById("skip-to-content");
  
    if(typeof(mainContent) != 'undefined' && mainContent != null && typeof(skipButton) != 'undefined' && skipButton != null) {
      skipButton.addEventListener('click', function( event) {
        event.preventDefault();
        mainContent.scrollIntoView();
        mainContent.focus();
      });
    }
  }

  // custom toggle on covid page
  const $covidSection = document.querySelector('#covid_sections');
  const $covidSection2 = document.querySelector('#covid_sections2');

  if($covidSection){
    const $toogleButtons = $covidSection.querySelectorAll('h3');
    
    $toogleButtons.forEach(($button) => {
      $button.addEventListener('click', el => {
        if (el.target.closest('section').querySelector('.custom-content').getAttribute('style') == 'display: none;')  {
          el.target.closest('section').querySelector('.custom-content').setAttribute('style', 'display: block;');
          el.target.parentNode.querySelector('img').setAttribute('style', 'transform: rotate(-90deg)');
        }
        else {
          el.target.closest('section').querySelector('.custom-content').setAttribute('style', 'display: none;');
          el.target.parentNode.querySelector('img').setAttribute('style', 'transform: rotate(90deg)');
        }
      });
      
      $button.addEventListener('keydown', el => {
        if (el.keyCode == 13 || el.which == 13){
          if (el.target.closest('section').querySelector('.custom-content').getAttribute('style') == 'display: none;')  {
            el.target.closest('section').querySelector('.custom-content').setAttribute('style', 'display: block;');
            el.target.parentNode.querySelector('img').setAttribute('style', 'transform: rotate(-90deg)');
          }
          else {
            el.target.closest('section').querySelector('.custom-content').setAttribute('style', 'display: none;');
            el.target.parentNode.querySelector('img').setAttribute('style', 'transform: rotate(90deg)');
          }
        }
      });
      

    });
  }

  if($covidSection2){
    console.log('new section');
    const $h2Button = $covidSection2.querySelector('h2.show-section');
    const $section  = $covidSection2.querySelector('.news-updates');
    
    $h2Button.addEventListener('click', el => {
      if ($section.querySelector('.custom-content').getAttribute('style') == 'display: none;')  {
        $section.querySelector('.custom-content').setAttribute('style', 'display: block;');
        $h2Button.querySelector('img').setAttribute('style', 'transform: rotate(-90deg)');
      }
      else {
        $section.querySelector('.custom-content').setAttribute('style', 'display: none;');
        $h2Button.querySelector('img').setAttribute('style', 'transform: rotate(90deg)');
      }
    });

    $h2Button.addEventListener('keydown', el => {
      if (el.keyCode == 13 || el.which == 13){
        if ($section.querySelector('.custom-content').getAttribute('style') == 'display: none;')  {
          $section.querySelector('.custom-content').setAttribute('style', 'display: block;');
          $h2Button.querySelector('img').setAttribute('style', 'transform: rotate(-90deg)');
        }
        else {
          $section.querySelector('.custom-content').setAttribute('style', 'display: none;');
          $h2Button.querySelector('img').setAttribute('style', 'transform: rotate(90deg)');
        }
      }
    });
  }

  const $notifButton = document.querySelector('.notification__action');
  if($notifButton){
    $notifButton.addEventListener('keydown', el => {
      if (el.keyCode == 13 || el.which == 13){
        document.querySelector('.notification__link').click();
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          'event': 'click_request_Admissions'
        })      
      }
    });
  }

  document.querySelector('.notification__link').addEventListener('click', el => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'click_request_Admissions'
    })
  });

  const socialLinks = document.querySelectorAll('.link-list--id-social-footer a');

  socialLinks.forEach(link => {
    link.addEventListener('click', e => { 
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
         'event': 'socialClick',
         'button_name': link.textContent
      })
    });
  })
}
